/*
 * @Author: 鲁博10 lubo10@hikvision.com.cn
 * @Date: 2024-08-12 19:56:18
 * @LastEditors: 鲁博10 lubo10@hikvision.com.cn
 * @LastEditTime: 2024-08-14 16:40:54
 * @FilePath: \city-h5\src\api\dynamicRouter.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// 公众号动态路由接口
import request from '../utils/service'

const api = {
  getWebPageConfig() {
    return request({
      url: '/basic/v2/api/webPageConfig',
      methods: 'get'
    })
  },
  getWebPageUrl(params) {
    return request({
      url: '/basic/v2/api/getH5Url',
      methods: 'get',
      params: params
    })
  },
  getHomeMenu(params) {
    return request({
      url: '/basic/v2/api/homeFuncEntries',
      methods: 'get',
      params: params
    })
  }

}

export default api
